import { render } from "./AffidavitComponent.vue?vue&type=template&id=bcb7cb14&scoped=true"
import script from "./AffidavitComponent.vue?vue&type=script&lang=js"
export * from "./AffidavitComponent.vue?vue&type=script&lang=js"

import "./AffidavitComponent.vue?vue&type=style&index=0&id=bcb7cb14&lang=scss&scoped=true"

import exportComponent from "/workspace/source/scm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcb7cb14"]])

export default __exports__